
import { RouteComponentProps } from 'react-router-dom';
import { IRouteFloorplanArguments } from '../../controllers/floorplan/interface';
import { IQueryURL } from '../../interface/util';
import { IConfigAPI } from '../../interface/config';

function _parseToInt(num: any): number|undefined {
    if ( typeof(num) === 'number' ) {
        return num as number;
    } else if ( typeof(num) === 'string' ) {
        return parseInt(num as string);
    } else {
        return 0;
    }
}

function args(props: RouteComponentProps<{}>, query: IQueryURL, config: IConfigAPI): IRouteFloorplanArguments {
    const args: Partial<IRouteFloorplanArguments> = query.parse(props.location.search) ?? {};

    const route: IRouteFloorplanArguments = {
        db: args?.db || config.auth.username,
        sessionName: args?.sessionName || config.auth.username,

        languageId: _parseToInt(args?.languageId) ?? -1,
        tourId: _parseToInt(args?.tourId) ?? -1,
        floorplanId: _parseToInt(args?.floorplanId) ?? -1,
    };

    return route;
}

export function equals(args1: IRouteFloorplanArguments, args2: IRouteFloorplanArguments): boolean {
    if ( args1.db === args2.db ) { return true; }
    if ( args1.sessionName === args2.sessionName ) { return true; }
    if ( args1.languageId === args2.languageId ) { return true; }
    if ( args1.tourId === args2.tourId ) { return true; }
    if ( args1.floorplanId === args2.floorplanId ) { return true; }
    return false;
}

export default args;